import { gql } from '@apollo/client';

export const LIMIT = 30;
export const ORDER = 'created_at DESC';

export const USER_ELIGIBILITY_FRAGMENT = gql`
  fragment FragmentUserEligibility on UserEligibility {
    id
    eligible
    eligibleAt
    lastTestAt
    company {
      id
    }
    user {
      id
      tester
      guest
      profile {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_USER_ELIGIBILITIES_BY_COMPANY = gql`
query UserEligibilities($companyId: ID!, $limit: Int!, $offset: Int!, $order: String!) {
  userEligibilities(companyId: $companyId, limit: $limit, offset: $offset, order: $order) {
    ...FragmentUserEligibility
  }
}
${USER_ELIGIBILITY_FRAGMENT}
`;

export const UPDATE_USER_ELIGIBILITY = gql`
  mutation UpdateUserEligibility($userId: ID!, $companyId: ID! $eligibility: Boolean!) {
    updateUserEligibility(userId: $userId, companyId: $companyId, eligibility: $eligibility) {
      userEligibility {
        id
        eligible
        eligibleAt
        lastTestAt
        user {
          id
          tester
          guest
          profile {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const CREATE_USER_ELIGIBILITY = gql`
  mutation CreateUserEligibility($identifier: ID!, $companyId: ID! $dateLastTest: String!) {
    createUserEligibility(identifier: $identifier, companyId: $companyId, dateLastTest: $dateLastTest) {
      userEligibility {
        ...FragmentUserEligibility
      }
    }
  }
  ${USER_ELIGIBILITY_FRAGMENT}
`;

export const handleCreateUserEligibityMutationUpdate = (cache, { data: { createUserEligibility } }) => {
  const { userEligibility } = createUserEligibility;
  const { company: { id: companyId } } = userEligibility;
  const { userEligibilities: cachedUserEligibilities } = cache.readQuery({
    query: GET_USER_ELIGIBILITIES_BY_COMPANY,
    variables: {
      companyId,
      limit: LIMIT,
      offset: 0,
      order: ORDER,
    },
  });

  const userEligibilities = [userEligibility, ...cachedUserEligibilities];

  cache.writeQuery({
    query: GET_USER_ELIGIBILITIES_BY_COMPANY,
    variables: {
      companyId,
      limit: LIMIT,
      offset: 0,
      order: ORDER,
    },
    data: {
      userEligibilities,
    },
  });
};
